<template>
  <div class="container is-fluid full-viewport" >
    <div class="columns">
      <div class="column is-offset-3 is-6">
        <div class="card">
          <div class="card-content">
            <div class="columns is-multiline is-mobile ">
              <div class="column is-12 ">
                <span class="has-text-weight-bold " >
                  {{ !esEditar ? 'Nuevo Usuario' : 'Editar Usuario' }}
                </span>
              </div>
            </div>
            <b-field
              label-position="on-border"
              class="lbl-align-center" >
              <template slot="label">
                Nombre
                <b-icon
                  class="pl-1"
                  pack="fas"
                  size="is-small"
                  type="is-danger"
                  icon="asterisk" />
              </template>
              <b-input
                ref="primer_campo"
                v-model="usuario.nombre"
                @blur="usuario.nombre = usuario.nombre ? usuario.nombre.trim() : null " />
            </b-field>
            <b-field
              label-position="on-border"
              class="lbl-align-center" >
              <template slot="label">
                E-Mail
                <b-icon
                  class="pl-1"
                  pack="fas"
                  size="is-small"
                  type="is-danger"
                  icon="asterisk" />
              </template>
              <b-input
                type="email"
                v-model="usuario.email" />
            </b-field>
            <div class="columns is-multiline"  >
              <div class="column is-6 pb-0">
                <span class="has-text-semibold" >
                  Actualizar Clave:
                  </span>
              </div>
              <div class="column is-6 has-text-left pb-0" >
                <b-switch
                  :rounded="false"
                  type="is-success"
                  passive-type='is-danger'
                  v-model="cambiarContrasenia" >
                  {{ cambiarContrasenia ? 'Sí' : 'No' }}
                </b-switch>
              </div>
            </div>
            <b-field
              v-if="cambiarContrasenia"
              label-position="on-border"
              class="lbl-align-center" >
              <template slot="label">
                Clave Actual
                <b-icon
                  class="pl-1"
                  pack="fas"
                  size="is-small"
                  type="is-danger"
                  icon="asterisk" />
              </template>
              <b-input
                v-model="claveSinMd5"
                type="password"
                password-reveal />
            </b-field>
            <b-field
              v-if="cambiarContrasenia"
              label-position="on-border"
              class="lbl-align-center" >
              <template slot="label">
                Nueva Clave
                <b-icon
                  class="pl-1"
                  pack="fas"
                  size="is-small"
                  type="is-danger"
                  icon="asterisk" />
              </template>
              <b-input
                v-model="claveNuevaSinMd5"
                type="password"
                password-reveal />
            </b-field>
            <b-field
              v-if="cambiarContrasenia"
              label-position="on-border"
              class="lbl-align-center" >
              <template slot="label">
                Confirmar Clave
                <b-icon
                  class="pl-1"
                  pack="fas"
                  size="is-small"
                  type="is-danger"
                  icon="asterisk" />
              </template>
              <b-input
                v-model="claveConfirmadaSinMd5"
                type="password"
                password-reveal />
            </b-field>
            <footer class="card-footer">
              <b-button
                class="card-footer-item align-center"
                type="is-info"
                @click="actualizar()" >
								<img src="@/assets/icons/Save.png" style="max-height:25px !important" >
                Guardar
              </b-button>
              <b-button
                class="card-footer-item align-center"
                type="is-danger"
                @click="volver()" >
								<img src="@/assets/icons/cancel-4.png" style="max-height:25px !important" >
                Cancelar
              </b-button>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import md5 from 'js-md5'
export default {
  props: {
    esEditar: {
      type: Boolean,
      default: false
    },
    objUsuario: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
			claveSinMd5: null,
			claveNuevaSinMd5: null,
			claveConfirmadaSinMd5: null,
      cambiarContrasenia: false,
      usuarioModelo: {
        id_usuario: null,
        nombre: null,
        email: null,
        estado_desc: 'Activo',
        estado: 'A'
      },
      usuario: {},
      listEstados: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.token,
    })
  },
  created () {
    if (this.esEditar) {
      this.usuario = { ...this.objUsuario }
    } else {
      this.usuario = { ...this.usuarioModelo }
    }
    this.obtenerDatosUsuario()
  },
  mounted() {
    if (this.$refs.primer_campo) {
      this.$refs.primer_campo.focus()
    }
  },
  methods: {
    async obtenerDatosUsuario () {
      try {
        const resultado = await this.$api.ejecutar('spr_sel_datos_sesion', [ this.token ])
        if (resultado != null) {
          if (resultado[0].status === 'SUCCESS') {
            this.usuario = { ...resultado[0] }
          } else {
            this.$alertifyNR.genericAlert(resultado[0].message, resultado[0].status)
            this.$router.push({ name: 'IniciarSesion' })
          }
        }
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
    },
    volver () {
      this.$router.push({ name: 'PaginaPrincipal' })
    },
    async actualizar () {
			if (this.usuario.nombre == null || !this.usuario.nombre ) {
				this.$alertifyNR.genericAlert("No se ha ingresado el Nombre del Usuario","ERROR")
				return
			}
      if (!this.usuario.email || this.usuario.email == null ||
					!(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(this.usuario.email))) {
				this.$alertifyNR.genericAlert('Ingrese un E-Mail valido')
				return
      }
      let clave = null
      let clave_nueva = null
      if (this.cambiarContrasenia) {
        if (this.claveSinMd5 == null || !this.claveSinMd5 ||
            this.claveNuevaSinMd5 == null || !this.claveNuevaSinMd5 ||
            this.claveConfirmadaSinMd5 == null || !this.claveConfirmadaSinMd5 ) {
          this.$alertifyNR.genericAlert("No se ha ingresado la Clave")
          return
        }
        if (this.claveNuevaSinMd5 !== this.claveConfirmadaSinMd5) {
          this.$alertifyNR.genericAlert("Claves No Coinciden")
          return 
        }
        let existe = this.claveSinMd5.indexOf(" ")
        if (existe > -1) {
          this.$alertifyNR.genericAlert("No se Permiten espacios en Clave","ERROR")
          return
        }
        this.claveSinMd5 = this.claveSinMd5.trim()
        let hash = md5.create()
        hash.update(this.claveSinMd5)
        clave = hash.hex()
        this.claveConfirmadaSinMd5 = this.claveConfirmadaSinMd5.trim()
        let hash2 = md5.create()
        hash2.update(this.claveConfirmadaSinMd5)
        clave_nueva = hash2.hex()
      }
      const params = [
        this.token,
        this.usuario.id_usuario,
        this.usuario.nombre,
        this.usuario.email,
        (this.cambiarContrasenia ? 'S' : 'N'),
        (this.cambiarContrasenia ? clave : null),
        (this.cambiarContrasenia ? clave_nueva : null)
      ]
      try {
				const resultado = await this.$api.ejecutar('spr_upd_perfil_usuario', params)
				if (resultado != null) {
          this.$alertifyNR.genericAlert(resultado[0].message, resultado[0].status)
					if (resultado[0].status === 'SUCCESS') {
            this.volver()
					}
				}
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
    }
  }
}
</script>